<template>
  <div>
    <request-detail
      :breadcrumRoutes="breadcrumRoutes"
      header-title="Nota de crédito"
      :request-id="request_id"
    />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import RequestDetailTemplate from '@/components/collection-and-billing/reprocesses-and-requests/requests/request-detail-template.vue';

export default {
  name: 'CreditNoteDetail',
  components: {
    'request-detail': RequestDetailTemplate
  },
  setup() {
    const breadcrumRoutes = [
      {
        breadcrumbName: 'Solicitud / Nota de Crédito'
      }
    ];
    const route = useRoute();
    const request_id = route.params.id;

    return {
      breadcrumRoutes,
      request_id
    };
  }
};
</script>

<style></style>
